var PlamsStrategyService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { AflaModuleStrategyService, SearchContainerHeight } from "./afla-module-strategy.service";
import _ from "underscore";
import { SaShortDatePipe } from "../../pipes/sa-short-date/sa-short-date.pipe";
import { ModuleConfig } from "../../models/module-config.model";
import { SharedConstants } from "../../constants/shared.constants";
import { SearchApplicantAgentComponent } from "../../../tabs/applications/application-search/search-applicant-agent/search-applicant-agent.component";
import { SearchAssignedToComponent } from "../../../tabs/applications/application-search/search-assigned-to/search-assigned-to.component";
import { ApplicationSearchService } from "../../../tabs/applications/shared/application-search.service";
import { catchError, distinctUntilChanged, map } from "rxjs/operators";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { BehaviorSubject, throwError } from "rxjs";
import { AppControllerService } from "../../../app-controller.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { OdataQueryService } from "../odata-query/odata-query.service";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { AlertType } from "../../models/alert";
import { WktConverterUtils } from "../../utils/wkt-converter-utils";
import { ApplicationSearchConstants } from "../../../tabs/applications/application-search/application-search-constants";
import { ODataAction } from "../odata-query/odata-action.model";
import { RequestStatusService } from "../request-status/request-status.service";
import { SearchCreatedDateComponent } from "../../../tabs/applications/application-search/search-created-date/search-created-date.component";
import { SearchApplicantInfoComponent } from "../../../tabs/applications/application-search/search-applicant-info/search-applicant-info.component";
import { Router } from "@angular/router";
import { SearchStatusComponent } from "../../../tabs/applications/application-search/search-status/search-status.component";
import { RecipientSelectService } from "../../components/recipient-select/shared/service/recipient-select.service";
import { SearchOptionsConstants } from "../../../core/settings/components/search-options/search-options-constants";
import { ApiSearchOptionConstants } from "../../constants/api-constants/api-search-option.constants";
import { ViewApplicationDetailsPlComponent } from "../../../application/view-application/modules/pl/view-application-details-pl/view-application-details-pl.component";
import { ViewApplicationLocationPlComponent } from "../../../application/view-application/modules/pl/view-application-location-pl/view-application-location-pl.component";
import { CreateApplicationDetailsPlComponent } from "../../../application/create-application/modules/pl/create-application-details-pl/create-application-details-pl.component";
import { CreateApplicationLocationPlComponent } from "../../../application/create-application/modules/pl/create-application-location-pl/create-application-location-pl.component";
import { ApiApplicationSearchConstants } from "../../constants/api-constants/api-application-search.constants";
import { ApiPropertyAndLeaseConstants } from "../../constants/api-constants/api-property-and-lease.constants";
import RecipientUtils from "../../utils/recipient-utils";
import { ApiProxyConstants } from "../../constants/api-constants/api-proxy.constants";
import { SearchOwnerInfoComponent } from "../../../tabs/applications/application-search/search-owner-info/search-owner-info.component";
import { SearchGroupInfoPlamsComponent } from "../../../tabs/applications/application-search/modules/pl/search-group-info-plams/search-group-info-plams.component";
import { SearchDeedTransferDateComponent } from "../../../tabs/applications/application-search/modules/pl/search-deed-transfer-date/search-deed-transfer-date.component";
import { SearchLeaseContractDateComponent } from "../../../tabs/applications/application-search/modules/pl/search-lease-contract-date/search-lease-contract-date.component";
import { ObjectUtils } from "../../utils/object-utils";
import { EsriDataTypeEnum } from "../../models/esri-data-type-enum";
import { SearchStartDateComponent } from "../../../tabs/applications/application-search/search-start-date/search-start-date.component";
import { SearchCategoryComponent } from "../../../tabs/applications/application-search/search-category/search-category.component";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
import { BpamsSearchOptions } from "./bpams-strategy.service";
import { ApplicationsRoutingConstants } from "../../../tabs/applications/applications-routing.constants";
import { ModulePrefix } from "../../models/module-prefix.model";
// Not to be sorted!!!! ==> Already in correct sort order
// Please do not rename the enums ==> it will break the SearchOptions Field?Column Settings! Labels can be changed without any impact.
export var PlamsSearchOptions;
(function (PlamsSearchOptions) {
    PlamsSearchOptions["ReferenceNumber"] = "Reference Number";
    PlamsSearchOptions["MyApplications"] = "My Applications";
    PlamsSearchOptions["AlienationInfo"] = "Alienation Information";
    PlamsSearchOptions["ApplicantAgent"] = "Applicant Agent";
    PlamsSearchOptions["ApplicantInfo"] = "Applicant Information";
    PlamsSearchOptions["AppID"] = "Application ID";
    PlamsSearchOptions["ApplicationStatus"] = "Application Status";
    PlamsSearchOptions["ApplicationsWithoutStartDate"] = "Applications Without Start Date";
    PlamsSearchOptions["ApplicationCategory"] = "Application Category";
    PlamsSearchOptions["AssignedToUsers"] = "Assigned to";
    PlamsSearchOptions["UnassignedApplications"] = "Unassigned Applications";
    PlamsSearchOptions["BuyerInfo"] = "Buyer Information";
    PlamsSearchOptions["CreatedDate"] = "Created Date";
    PlamsSearchOptions["CreatedDateRange"] = "Created Date Range";
    PlamsSearchOptions["StartDate"] = "Started Date";
    PlamsSearchOptions["StartDateRange"] = "Started Date Range";
    PlamsSearchOptions["DaysUntilExpired"] = "Days until Expired";
    PlamsSearchOptions["LesseeInfo"] = "Lessee Information";
    PlamsSearchOptions["LeaseContractInfo"] = "Lease Contract Information";
    PlamsSearchOptions["OwnerInfo"] = "Owner Information";
    PlamsSearchOptions["PercentageComplete"] = "Percentage Complete";
    PlamsSearchOptions["SellerInfo"] = "Seller Information";
    PlamsSearchOptions["TimeoutStatus"] = "Timeout Status";
    PlamsSearchOptions["TransferAttorneyInfo"] = "Transfer Attorney Information";
    PlamsSearchOptions["JobID"] = "Job ID";
})(PlamsSearchOptions || (PlamsSearchOptions = {}));
// TODO these columns will change depending on how columns have been configured. This is the default list
export var ApplicationHeadingEnum;
(function (ApplicationHeadingEnum) {
    ApplicationHeadingEnum["ReferenceNumber"] = "Reference Number";
    ApplicationHeadingEnum["Applicant"] = "Applicant";
    ApplicationHeadingEnum["Agent"] = "Agent";
    ApplicationHeadingEnum["ApplicationType"] = "Application Type";
    ApplicationHeadingEnum["LeaseStartDate"] = "Lease Start Date";
    ApplicationHeadingEnum["LeaseEndDate"] = "Lease End Date";
    ApplicationHeadingEnum["LeaseApplicationStatus"] = "Lease Application Status";
    ApplicationHeadingEnum["LeaseType"] = "Lease Type";
    ApplicationHeadingEnum["DateOfDeedTransfer"] = "Date of Deed Transfer";
    ApplicationHeadingEnum["SaleAmount"] = "Sale Amount";
    ApplicationHeadingEnum["EvaluationAmount"] = "Evaluation Amount";
    ApplicationHeadingEnum["ApplicationStatus"] = "Application Status";
    ApplicationHeadingEnum["DaysLeft"] = "Days left";
    ApplicationHeadingEnum["LastEditedBy"] = "Last Edited By";
    ApplicationHeadingEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationHeadingEnum || (ApplicationHeadingEnum = {}));
export const applicationHeadingLookup = new Map([
    [ApplicationHeadingEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationHeadingEnum.Applicant, "applicant"],
    [ApplicationHeadingEnum.Agent, "agent"],
    [ApplicationHeadingEnum.ApplicationType, "applicationType"],
    [ApplicationHeadingEnum.LeaseStartDate, "leaseStartDate"],
    [ApplicationHeadingEnum.LeaseEndDate, "leaseEndDate"],
    [ApplicationHeadingEnum.LeaseApplicationStatus, "leaseApplicationStatus"],
    [ApplicationHeadingEnum.LeaseType, "leaseType"],
    [ApplicationHeadingEnum.DateOfDeedTransfer, "dateOfDeedTransfer"],
    [ApplicationHeadingEnum.SaleAmount, "saleAmount"],
    [ApplicationHeadingEnum.EvaluationAmount, "evaluationAmount"],
    [ApplicationHeadingEnum.ApplicationStatus, "phase"],
    [ApplicationHeadingEnum.DaysLeft, "daysLeft"],
    [ApplicationHeadingEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationHeadingEnum.LastEditedOn, "lastEditedOn"],
]);
export var ApplicationSummaryColumnsEnum;
(function (ApplicationSummaryColumnsEnum) {
    ApplicationSummaryColumnsEnum["ReferenceNumber"] = "Reference Number";
    ApplicationSummaryColumnsEnum["Applicant"] = "Applicant";
    ApplicationSummaryColumnsEnum["Agent"] = "Agent";
    ApplicationSummaryColumnsEnum["ErfNumber"] = "Erf Number";
    ApplicationSummaryColumnsEnum["FarmNumber"] = "Farm Number";
    ApplicationSummaryColumnsEnum["ApplicationType"] = "Application Type";
    ApplicationSummaryColumnsEnum["StartDate"] = "Start Date";
    ApplicationSummaryColumnsEnum["Phase"] = "Phase";
    ApplicationSummaryColumnsEnum["DaysLeft"] = "Days left";
    ApplicationSummaryColumnsEnum["LastEditedBy"] = "Last Edited By";
    ApplicationSummaryColumnsEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationSummaryColumnsEnum || (ApplicationSummaryColumnsEnum = {}));
export const applicationSummaryColumnsLookup = new Map([
    [ApplicationSummaryColumnsEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationSummaryColumnsEnum.Applicant, "applicant"],
    [ApplicationSummaryColumnsEnum.Agent, "agent"],
    [ApplicationSummaryColumnsEnum.ErfNumber, "erfNumbers"],
    [ApplicationSummaryColumnsEnum.FarmNumber, "farmNumbers"],
    [ApplicationSummaryColumnsEnum.ApplicationType, "applicationType"],
    [ApplicationSummaryColumnsEnum.StartDate, "startDate"],
    [ApplicationSummaryColumnsEnum.Phase, "phase"],
    [ApplicationSummaryColumnsEnum.DaysLeft, "daysLeft"],
    [ApplicationSummaryColumnsEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationSummaryColumnsEnum.LastEditedOn, "lastEditedOn"],
]);
export const PlamsSearchQueryLookup = new Map([
    [PlamsSearchOptions.AppID, "appId"],
    [PlamsSearchOptions.ReferenceNumber, "referenceNumber"],
    [PlamsSearchOptions.JobID, "jobId"]
]);
export const PlamsAdditionalSearchOptions = [PlamsSearchOptions.MyApplications,
    PlamsSearchOptions.AssignedToUsers,
    PlamsSearchOptions.UnassignedApplications,
    PlamsSearchOptions.ApplicationsWithoutStartDate];
export const PlamsDateSearchOptions = new Map([
    [PlamsSearchOptions.CreatedDate, 1],
    [PlamsSearchOptions.CreatedDateRange, 2],
    [PlamsSearchOptions.AlienationInfo, 1],
    [PlamsSearchOptions.LeaseContractInfo, 1],
]);
export const PlamsStartRangeDateSearchOptions = new Map([
    [PlamsSearchOptions.StartDate, 1],
    [PlamsSearchOptions.StartDateRange, 2]
]);
export const PlamsStatusSearchOptions = new Map([
    [PlamsSearchOptions.ApplicationStatus, ApplicationSearchConstants.STATUS],
    [PlamsSearchOptions.PercentageComplete, ApplicationSearchConstants.PERCENT_COMPLETE],
    [PlamsSearchOptions.DaysUntilExpired, ApplicationSearchConstants.DAYS_UNTIL_EXPIRED],
    [PlamsSearchOptions.TimeoutStatus, ApplicationSearchConstants.TIMEOUT_STATUS],
]);
export const PlamsGroupSearchOptions = new Map([
    [PlamsSearchOptions.TransferAttorneyInfo, ApplicationSearchConstants.TRANSFER_ATTORNEY],
    [PlamsSearchOptions.LesseeInfo, ApplicationSearchConstants.LESSEES],
    [PlamsSearchOptions.SellerInfo, ApplicationSearchConstants.SELLERS],
    [PlamsSearchOptions.BuyerInfo, ApplicationSearchConstants.BUYERS],
]);
export const PlamsSearchOptionClientHeight = new Map([
    [PlamsSearchOptions.ReferenceNumber, SearchContainerHeight.Simple],
    [PlamsSearchOptions.MyApplications, SearchContainerHeight.Simple],
    [PlamsSearchOptions.AppID, SearchContainerHeight.Simple],
    [PlamsSearchOptions.ApplicationStatus, SearchContainerHeight.SingleLine],
    [PlamsSearchOptions.PercentageComplete, SearchContainerHeight.SingleLine],
    [PlamsSearchOptions.DaysUntilExpired, SearchContainerHeight.SingleLine],
    [PlamsSearchOptions.TimeoutStatus, SearchContainerHeight.SingleLine],
    [PlamsSearchOptions.CreatedDate, SearchContainerHeight.SingleLine],
    [PlamsSearchOptions.AssignedToUsers, SearchContainerHeight.SingleLine],
    [PlamsSearchOptions.CreatedDateRange, SearchContainerHeight.SingleLine],
    [PlamsSearchOptions.AlienationInfo, SearchContainerHeight.SingleLine],
    [PlamsSearchOptions.LeaseContractInfo, SearchContainerHeight.SingleLine],
    [PlamsSearchOptions.ApplicantAgent, SearchContainerHeight.Extended],
    [PlamsSearchOptions.ApplicantInfo, SearchContainerHeight.Extended],
    [PlamsSearchOptions.OwnerInfo, SearchContainerHeight.Extended],
    [PlamsSearchOptions.BuyerInfo, SearchContainerHeight.Extended],
    [PlamsSearchOptions.SellerInfo, SearchContainerHeight.Extended],
    [PlamsSearchOptions.TransferAttorneyInfo, SearchContainerHeight.Extended],
    [PlamsSearchOptions.LesseeInfo, SearchContainerHeight.Extended],
]);
// IMPORTANT: these values much match the DB table names and the Property names used by oData entity for TownPlanning
export var PlamsSearchOptionTableListEnum;
(function (PlamsSearchOptionTableListEnum) {
    PlamsSearchOptionTableListEnum["Application"] = "PL_APPLICATION|Application";
    PlamsSearchOptionTableListEnum["Property"] = "PL_APPLICATIONPROPERTY|Properties";
    PlamsSearchOptionTableListEnum["Owner"] = "AFLA_Recipient|Owner";
    PlamsSearchOptionTableListEnum["Status"] = "AFLA_APPLICATIONSTATUS|Status";
    PlamsSearchOptionTableListEnum["Applicant"] = "AFLA_Recipient|Applicant";
    PlamsSearchOptionTableListEnum["ApplicantAgent"] = "AFLA_Recipient|ApplicantAgent";
    PlamsSearchOptionTableListEnum["Buyer"] = "AFLA_Recipient|Buyer";
    PlamsSearchOptionTableListEnum["Seller"] = "AFLA_Recipient|Seller";
    PlamsSearchOptionTableListEnum["Lessee"] = "AFLA_Recipient|Lessee";
    PlamsSearchOptionTableListEnum["TransferAttorney"] = "AFLA_Recipient|TransferAttorney";
})(PlamsSearchOptionTableListEnum || (PlamsSearchOptionTableListEnum = {}));
export const BpamsBuildingUseSearchOptions = new Map([
    [BpamsSearchOptions.BuildingUse, ApplicationSearchConstants.BUILDING_USE],
]);
export const PLExpandListForApplicationSearch = ApplicationSearchConstants.APP_SEARCH_EXPAND_LIST_PL;
export const PLExpandListForApplicationSearchWithGroups = ApplicationSearchConstants.APP_SEARCH_EXPAND_FULL_LIST_PL;
export const PLTableNameListForSearchOptions = PlamsSearchOptionTableListEnum.Application
    + "," + PlamsSearchOptionTableListEnum.Property
    + "," + PlamsSearchOptionTableListEnum.Owner
    + "," + PlamsSearchOptionTableListEnum.Status
    + "," + PlamsSearchOptionTableListEnum.Applicant
    + "," + PlamsSearchOptionTableListEnum.ApplicantAgent
    + "," + PlamsSearchOptionTableListEnum.Buyer
    + "," + PlamsSearchOptionTableListEnum.Seller
    + "," + PlamsSearchOptionTableListEnum.Lessee
    + "," + PlamsSearchOptionTableListEnum.TransferAttorney;
export var CreateApplicationMenuHeadings;
(function (CreateApplicationMenuHeadings) {
    CreateApplicationMenuHeadings["Details"] = "Details";
    CreateApplicationMenuHeadings["ApplicantAgent"] = "Applicant / Agent";
    CreateApplicationMenuHeadings["Location"] = "Location";
    CreateApplicationMenuHeadings["Notes"] = "Notes";
})(CreateApplicationMenuHeadings || (CreateApplicationMenuHeadings = {}));
export var ViewApplicationMenuHeadings;
(function (ViewApplicationMenuHeadings) {
    ViewApplicationMenuHeadings["Details"] = "Details";
    ViewApplicationMenuHeadings["Applicant"] = "Applicant / applicant agent";
    ViewApplicationMenuHeadings["Location"] = "Location";
    ViewApplicationMenuHeadings["Assessment"] = "Assessment";
    ViewApplicationMenuHeadings["Attachments"] = "Attachments";
    ViewApplicationMenuHeadings["Checklist"] = "Checklist";
    ViewApplicationMenuHeadings["Comments"] = "Comments";
    ViewApplicationMenuHeadings["Communication"] = "Communication";
    ViewApplicationMenuHeadings["Conditions"] = "Conditions";
    ViewApplicationMenuHeadings["History"] = "History";
    ViewApplicationMenuHeadings["Invoices"] = "Invoices";
    ViewApplicationMenuHeadings["Notes"] = "Notes";
    ViewApplicationMenuHeadings["RelatedApplicationSearch"] = "Related applications";
    ViewApplicationMenuHeadings["RequiredDocumentsChecklist"] = "Required documents checklist";
    ViewApplicationMenuHeadings["Result"] = "Result";
    ViewApplicationMenuHeadings["ScheduledReminders"] = "Scheduled Reminders";
    ViewApplicationMenuHeadings["Status"] = "Status";
    ViewApplicationMenuHeadings["StepManagement"] = "Step management";
    ViewApplicationMenuHeadings["Survey123"] = "Survey123";
    ViewApplicationMenuHeadings["Timeouts"] = "Timeouts";
    ViewApplicationMenuHeadings["Team"] = "Team";
})(ViewApplicationMenuHeadings || (ViewApplicationMenuHeadings = {}));
export var SettingsMenuHeadings;
(function (SettingsMenuHeadings) {
    SettingsMenuHeadings["AvailableSurvey123s"] = "Available survey123s";
    SettingsMenuHeadings["Lookups"] = "Lookups";
    SettingsMenuHeadings["MapConfig"] = "Map services";
    SettingsMenuHeadings["NonWorkingDays"] = "Non-working days";
    SettingsMenuHeadings["AttachmentTypes"] = "Attachment types";
    SettingsMenuHeadings["Recipients"] = "Recipients";
    SettingsMenuHeadings["RecipientGroups"] = "Recipient groups";
    SettingsMenuHeadings["Reports"] = "Reports";
    SettingsMenuHeadings["StepMetaData"] = "Step metadata";
    SettingsMenuHeadings["Tariffs"] = "Tariffs";
    SettingsMenuHeadings["Templates"] = "Templates";
    SettingsMenuHeadings["NotificationTemplates"] = "Notification templates";
    SettingsMenuHeadings["ModuleRoles"] = "Module roles";
    SettingsMenuHeadings["AFLAPortalDocuments"] = "Afla portal documents";
    SettingsMenuHeadings["AFLAPortalUpdateOwners"] = "Afla portal update owners";
    SettingsMenuHeadings["SearchOptions"] = "Search options";
    SettingsMenuHeadings["SearchSettings"] = "Search settings";
    SettingsMenuHeadings["BackupRestore"] = "Backup and restore";
    SettingsMenuHeadings["ArcGISItems"] = "ArcGIS items";
    SettingsMenuHeadings["AFLAPortalMessagesAndPages"] = "AFLA portal messages and pages";
    SettingsMenuHeadings["InvoiceTemplates"] = "Invoice templates";
    SettingsMenuHeadings["Stamps"] = "Stamps";
    SettingsMenuHeadings["ApplicationWorkflowUpgrade"] = "Application workflow upgrade";
})(SettingsMenuHeadings || (SettingsMenuHeadings = {}));
export const PlRequiredMapFields = [{
        mapName: "Property",
        fields: [
            { name: "OBJECTID", type: EsriDataTypeEnum.oid },
            { name: "SgCode", type: EsriDataTypeEnum.string },
            { name: "ErfNo", type: EsriDataTypeEnum.string },
            { name: "FarmNo", type: EsriDataTypeEnum.string },
            { name: "PtnNum", type: EsriDataTypeEnum.string },
            { name: "Allotment", type: EsriDataTypeEnum.string },
            { name: "PropertyDescription", type: EsriDataTypeEnum.string },
            { name: "Address", type: EsriDataTypeEnum.string },
            { name: "TotalValue", type: EsriDataTypeEnum.integer },
            { name: "HasGeometry", type: EsriDataTypeEnum.integer },
            { name: "ErfSize", type: EsriDataTypeEnum.integer },
            { name: "TitleDeed", type: EsriDataTypeEnum.string },
            { name: "SectionalTitleSchemeID", type: EsriDataTypeEnum.string },
            { name: "Type", type: EsriDataTypeEnum.string },
            { name: "LegalStatus", type: EsriDataTypeEnum.string },
            { name: "FloorNo", type: EsriDataTypeEnum.string },
            { name: "FloorName", type: EsriDataTypeEnum.string },
            { name: "SgDiagramNo", type: EsriDataTypeEnum.string },
            { name: "UnitNumber", type: EsriDataTypeEnum.integer },
            { name: "Registered", type: EsriDataTypeEnum.smallInteger },
            { name: "SgCodeExternal", type: EsriDataTypeEnum.string },
            { name: "PremiseID", type: EsriDataTypeEnum.string },
            { name: "AccountNo", type: EsriDataTypeEnum.string },
            { name: "ZoningCategory", type: EsriDataTypeEnum.string },
            { name: "Shape", type: EsriDataTypeEnum.geometry },
            { name: "Shape_Area", type: EsriDataTypeEnum.double },
            { name: "Shape_Length", type: EsriDataTypeEnum.double }
        ]
    }];
let PlamsStrategyService = class PlamsStrategyService extends AflaModuleStrategyService {
    static { PlamsStrategyService_1 = this; }
    saShortDatePipe;
    applicationSearchService;
    appControllerService;
    oDataQueryService;
    requestStatusService;
    http;
    appController;
    router;
    recipientSelectService;
    buildingUseSearchOptions;
    overdueApplicationExpandFields = "status, applicant";
    showApplicantAgentForModule = true;
    requiredMapFields;
    createApplicationMenuHeadings;
    overrideMapDefault = {};
    viewApplicationComponentLookup;
    name = ModuleConfig.PropertyAndLease;
    modulePrefix = ModulePrefix.PropertyAndLease;
    searchQueryLookup;
    defaultSearchColumns;
    searchOptions;
    applicationEndpoint;
    extendedSimpleSearchOptions;
    dateSearchOptions;
    RangeSearchOptions;
    statusSearchOptions;
    groupSearchOptions;
    clientHeightMap;
    createApplicationComponentLookup;
    advancedSearchComponentLookup;
    viewApplicationMenuHeadings;
    applicationSummaryColumnsMap;
    // column headers are dynamic
    applicationTableColumnMap = new BehaviorSubject(null);
    applicationTableColumnMapObservable;
    applicationServiceUrl = ApiPropertyAndLeaseConstants.URL;
    form;
    lookups = new Map();
    userId;
    moduleUsers;
    expandListForApplicationSearch = PLExpandListForApplicationSearch;
    expandListForApplicationSearchFullList = PLExpandListForApplicationSearchWithGroups;
    searchOptionTableNameList = PLTableNameListForSearchOptions;
    customApplicationTableColumnMap;
    selectedSearchOptionLookup;
    searchOptionsWithCustomColumns = [];
    searchOptionsFieldList;
    searchOptionsMap;
    isPrevSavedSearch = false;
    aflaPortalConfigurableMessages = [
        "Welcome help",
        "Welcome page",
        "Property help",
        "Application help",
        "Agent help",
        "Required documentation help",
        "Notes help",
        "Applicant help",
        "Summary help",
        "Create application status page",
        "View application status page",
        "Communication help"
    ];
    setApplicantAndApplicantAgentAction = ApiPropertyAndLeaseConstants.FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT;
    settingsMenuHeadings;
    settingsComponentLookup;
    propertiesPageHeading = "Properties";
    moduleRequiredMaps;
    stampOptions = [];
    previousApplication = null;
    statusColumn = "status/ workflowSection";
    createApplicationPlamsSubscription;
    constructor(saShortDatePipe, applicationSearchService, appControllerService, oDataQueryService, requestStatusService, http, appController, router, recipientSelectService) {
        super();
        this.saShortDatePipe = saShortDatePipe;
        this.applicationSearchService = applicationSearchService;
        this.appControllerService = appControllerService;
        this.oDataQueryService = oDataQueryService;
        this.requestStatusService = requestStatusService;
        this.http = http;
        this.appController = appController;
        this.router = router;
        this.recipientSelectService = recipientSelectService;
        this.initForm();
        this.applicationEndpoint = ApiApplicationSearchConstants.PROPERTY_AND_LEASE_ENDPOINT;
        this.createApplicationMenuHeadings = CreateApplicationMenuHeadings;
        this.viewApplicationMenuHeadings = ViewApplicationMenuHeadings;
        this.settingsMenuHeadings = SettingsMenuHeadings;
        this.moduleRequiredMaps = ["Property"];
        this.requiredMapFields = PlRequiredMapFields;
        super.init();
    }
    static getRecipientFullName(firstName, surname) {
        if (!firstName && !surname) {
            return "";
        }
        if (!firstName) {
            return surname;
        }
        return `${firstName} ${surname}`;
    }
    static getRecipientName(recipient) {
        if (!recipient) {
            return "";
        }
        return this.getRecipientFullName(recipient.name, recipient.surname);
    }
    // the format for a column filter on an child table is:
    //    EQUALS ==> applicantAgent/any(m:m/name eq 'xxxx')
    //    CONTAINS with tolower ==> applicantAgent/any(b:contains(tolower(b/name),'xxxx'))
    static buildColumnFilter(text, filter) {
        const column = filter ? filter : ApplicationSearchConstants.DEFAULT_SEARCH;
        return `contains(tolower(cast(${column.trim()},'Edm.String')),'${text.trim().toLowerCase()}') and eLodgementComplete eq true`;
    }
    static buildExpand(params, top) {
        params = params.set(ODataAction.Expand, PLExpandListForApplicationSearch);
        params = params.set(ODataAction.Top, top);
        params = params.set(ODataAction.OrderBy, "startDate ne null desc, startDate desc, appId desc");
        return params;
    }
    static getFirstRecipient(recipients) {
        if (recipients && recipients.length > 0) {
            return recipients[0];
        }
    }
    buildListFilter(list, column) {
        const params = PlamsStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        return this.oDataQueryService.buildFilterFromArray(params, column, list);
    }
    getStatusForModule(moduleID, statusField) {
        return this.applicationSearchService.getStatusForModule(moduleID, statusField);
    }
    getUsersForModule(moduleID) {
        return this.applicationSearchService.getUsersForModule(moduleID);
    }
    initializeSearchQueryLookup() {
        this.searchQueryLookup = PlamsSearchQueryLookup;
    }
    initializeAdditionalSearchLookup() {
        this.extendedSimpleSearchOptions = PlamsAdditionalSearchOptions;
    }
    initializeApplicationSummaryColumnsMap() {
        this.applicationSummaryColumnsMap = applicationSummaryColumnsLookup;
    }
    initializeSearchOptionsLookup() {
        this.searchOptions = new Array();
        this.searchOptions.push(..._.values(PlamsSearchOptions));
        // this is used for the SearchOptions settings
        this.searchOptionsMap = new Map();
        for (const [key, value] of Object.entries(PlamsSearchOptions)) {
            this.searchOptionsMap.set(key, value);
        }
        // default column list if search option types does not have a default
        this.defaultSearchColumns = applicationHeadingLookup;
    }
    initializeDateSearchOptions() {
        this.dateSearchOptions = PlamsDateSearchOptions;
        this.RangeSearchOptions = PlamsStartRangeDateSearchOptions;
    }
    initializeStatusSearchOptions() {
        this.statusSearchOptions = PlamsStatusSearchOptions;
        this.clientHeightMap = PlamsSearchOptionClientHeight;
    }
    initializeGroupSearchOptions() {
        this.groupSearchOptions = PlamsGroupSearchOptions;
        this.clientHeightMap = PlamsSearchOptionClientHeight;
    }
    getFieldListForSearchOptions(moduleId) {
        const params = {
            $filter: PlamsStrategyService_1.buildModuleIDFilter(moduleId),
            $expand: SearchOptionsConstants.SEARCH_OPTIONS_EXPAND,
            $orderby: SearchOptionsConstants.SEARCH_OPTIONS_COLUMNS_ORDERBY
        };
        const url = `${ApiSearchOptionConstants.URL}`;
        return this.http.get(url, { params }).pipe(map((response) => {
            this.searchOptionsWithCustomColumns = [];
            this.searchOptionsFieldList = response.value;
            this.searchOptionsFieldList.forEach((option) => {
                const searchOptionLookup = this.getSearchOptionLookup(option.searchOption);
                // @ts-ignore
                if (this.searchOptionsWithCustomColumns.indexOf(searchOptionLookup) < 0) { // @ts-ignore
                    this.searchOptionsWithCustomColumns.push(searchOptionLookup);
                }
            });
            return response.value;
        }));
    }
    defaultSearchModel(application) {
        return {
            id: application.id,
            appId: application.appId,
            jobId: application.jobId,
            referenceNumber: application.referenceNumber,
            applicant: PlamsStrategyService_1.getRecipientName(PlamsStrategyService_1.getFirstRecipient(application.applicant)),
            agent: PlamsStrategyService_1.getRecipientName(PlamsStrategyService_1.getFirstRecipient(application.applicantAgent)),
            erfNumbers: ObjectUtils.getCommaSeparatedValuesFromListForKey(application.properties, "erfNumber"),
            farmNumbers: ObjectUtils.getCommaSeparatedValuesFromListForKey(application.properties, "farmNumber"),
            startDate: application.createdDate !== null
                ? this.saShortDatePipe.transform(application.startDate)
                : "",
            phase: application.status?.workflowSection,
            daysLeft: application.status?.daysUntilExpired,
            lastEditedBy: this.getLastEditedByUser(application.lastEditedUser),
            lastEditedOn: application.lastEditedDate !== null
                ? this.saShortDatePipe.transform(application.lastEditedDate)
                : "",
            moduleId: application.moduleId,
            applicationType: application.applicationType,
            leaseStartDate: application.leaseStartDate
                ? this.saShortDatePipe.transform(application.leaseStartDate)
                : "",
            leaseEndDate: application.leaseEndDate
                ? this.saShortDatePipe.transform(application.leaseEndDate)
                : "",
            leaseApplicationStatus: application.leaseApplicationStatus,
            leaseType: application.leaseType,
            dateOfDeedTransfer: application.dateOfDeedTransfer
                ? this.saShortDatePipe.transform(application.dateOfDeedTransfer)
                : "",
            saleAmount: application.saleAmount,
            evaluationAmount: application.evaluationAmount
        };
    }
    getLastEditedByUser(lastEditedUser) {
        return lastEditedUser ? `${lastEditedUser.lastName}, ${lastEditedUser.firstName}` : "";
    }
    getApplicationFieldValue(application, appGroup, fieldName) {
        let fieldValue;
        for (const [key, value] of Object.entries(application)) {
            if (!fieldValue && appGroup.toLowerCase() === "application") {
                if (key.toLowerCase() === fieldName.toLowerCase()) {
                    fieldValue = value;
                    break;
                }
            }
            else {
                if (!fieldValue
                    && key.toLowerCase() === appGroup.toLowerCase()) {
                    // some applications may have null lower order properties e.g. Status
                    if (value) {
                        const group = value[0] ? value[0] : value;
                        for (const [groupKey, groupValue] of Object.entries(group)) {
                            switch (appGroup.toLowerCase()) {
                                case "applicant":
                                case "applicantagent":
                                case "transferattorney":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        fieldValue = groupValue;
                                    }
                                    break;
                                case "status":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        switch (fieldName.toLowerCase()) {
                                            case "assignedto":
                                            case "createdby":
                                                // these fields will be handled in the user section below
                                                break;
                                            default:
                                                fieldValue = groupValue;
                                                break;
                                        }
                                        break;
                                    }
                                    break;
                                // the following properties can be multiple values - we cannot use ObjectUtils.getCommaSeparatedValuesFromListForKey because it is case sensitive
                                case "buyers":
                                case "sellers":
                                case "lessees":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        fieldValue = fieldValue ? fieldValue += ", " + groupValue : groupValue;
                                    }
                                    break;
                            }
                        }
                    }
                }
                if (fieldValue)
                    break;
            }
        }
        // Owner is the only 3rd level table that is referenced
        if (!fieldValue && appGroup.toLowerCase() === "owners") {
            if (application.properties.length > 0) {
                for (const [propkey, propVal] of Object.entries(application.properties[0])) {
                    if (propkey.toLowerCase() === appGroup.toLowerCase()) {
                        for (const [groupKey, groupValue] of Object.entries(propVal)) {
                            if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                fieldValue = groupValue;
                                break;
                            }
                        }
                    }
                }
            }
        }
        if (!fieldValue)
            fieldValue = "";
        if (fieldName.toLowerCase().endsWith("date") || fieldName.toLowerCase().startsWith("date")) {
            fieldValue = fieldValue ? this.saShortDatePipe.transform(fieldValue) : "";
        }
        else {
            switch (fieldName.toLowerCase()) {
                case "lasteditedby":
                    fieldValue = this.getUserName(application.lastEditedUser);
                    break;
                case "createdby":
                    fieldValue = application.status ? this.getUserNameFromId(application.status.createdBy) : "";
                    break;
                case "assignedto":
                    fieldValue = application.status ? this.getUserNameFromId(application.status.assignedTo) : "";
                    break;
                case "createduserid":
                    fieldValue = this.getUserName(application.createdSystemUser);
                    break;
            }
        }
        return fieldValue;
    }
    customColumnSearchModel(application, columnList, isPrevSavedSearch = false) {
        // need to reset the column map if the search options customised columns have been updated
        if ((this.customApplicationTableColumnMap.size !== 0 && columnList.length !== this.customApplicationTableColumnMap.size)
            || isPrevSavedSearch) {
            this.customApplicationTableColumnMap.clear();
            this.isPrevSavedSearch = false;
        }
        let resetHeadings = this.customApplicationTableColumnMap.size === 0;
        const appDetails = {};
        if (columnList.length > 0) {
            columnList.forEach((column) => {
                const fieldAlias = column.moduleField.fieldAlias;
                const fieldName = column.moduleField.fieldName;
                const tableLookup = this.getSearchOptionLookup(`${column.moduleField.tableAlias}`);
                const appGroup = this.getApplicationTableProperty(`${column.moduleField.tableName}|${tableLookup}`);
                const appProperty = `${appGroup.toLowerCase()}${fieldName.toLowerCase()}`;
                appDetails[appProperty] = this.getApplicationFieldValue(application, tableLookup, fieldName);
                if (resetHeadings)
                    this.customApplicationTableColumnMap.set(fieldAlias, appProperty);
            });
            // standard fields to add in case the user did not add them
            // @ts-ignore
            appDetails.id = application.id;
            // @ts-ignore
            appDetails.moduleId = application.moduleId;
            // @ts-ignore
            appDetails.jobId = application.jobId;
            // @ts-ignore
            appDetails.appId = application.appId;
            // only set the headings once for the search
            if (resetHeadings) {
                this.changeAppTableColumnMap(this.customApplicationTableColumnMap);
                resetHeadings = false;
            }
            return appDetails;
        }
        else
            return this.defaultSearchModel(application);
    }
    getApplicationTableProperty(tableName) {
        let property = "";
        for (const [tableKey, tableValue] of Object.entries(PlamsSearchOptionTableListEnum)) {
            if (tableValue.toLowerCase() === tableName.toLowerCase()) {
                // @ts-ignore
                property = tableKey;
                break;
            }
        }
        return property;
    }
    getUserNameFromId(userId) {
        let userName = "";
        if (userId) {
            this.applicationSearchService.moduleUsers.forEach((user) => {
                if (Number(user.id) === userId)
                    userName = `${user.lastName}, ${user.firstName}`;
            });
        }
        return userName;
    }
    getUserName(user) {
        return user ? `${user.lastName}, ${user.firstName}` : "";
    }
    getCustomApplicationSearchModel(searchOptionLookup) {
        // identify columnList for specific search option
        return this.applicationSearchService.getSearchOptionColumnList(this, searchOptionLookup);
    }
    mapFromApplicationEntityToApplicationSearchModel(application) {
        if (application) {
            return this.defaultSearchModel(application);
        }
    }
    initializeSettingsComponents() {
        this.settingsComponentLookup = new Map([]);
    }
    initializeViewApplicationComponents() {
        this.viewApplicationComponentLookup = new Map([
            [
                ViewApplicationMenuHeadings.Details,
                ViewApplicationDetailsPlComponent,
            ],
            [
                ViewApplicationMenuHeadings.Location,
                ViewApplicationLocationPlComponent
            ],
        ]);
    }
    initializeCreateApplicationComponents() {
        this.createApplicationComponentLookup = new Map([
            [
                CreateApplicationMenuHeadings.Details,
                CreateApplicationDetailsPlComponent,
            ],
            [
                CreateApplicationMenuHeadings.Location,
                CreateApplicationLocationPlComponent,
            ],
        ]);
    }
    initializeAdvancedApplicationSearchComponents() {
        this.advancedSearchComponentLookup = new Map([
            [PlamsSearchOptions.ApplicantAgent, SearchApplicantAgentComponent],
            [PlamsSearchOptions.AssignedToUsers, SearchAssignedToComponent],
            [PlamsSearchOptions.CreatedDate, SearchCreatedDateComponent],
            [PlamsSearchOptions.CreatedDateRange, SearchCreatedDateComponent],
            [PlamsSearchOptions.StartDate, SearchStartDateComponent],
            [PlamsSearchOptions.StartDateRange, SearchStartDateComponent],
            [PlamsSearchOptions.ApplicantInfo, SearchApplicantInfoComponent],
            [PlamsSearchOptions.PercentageComplete, SearchStatusComponent],
            [PlamsSearchOptions.ApplicationStatus, SearchStatusComponent],
            [PlamsSearchOptions.ApplicationCategory, SearchCategoryComponent],
            [PlamsSearchOptions.TimeoutStatus, SearchStatusComponent],
            [PlamsSearchOptions.DaysUntilExpired, SearchStatusComponent],
            [PlamsSearchOptions.OwnerInfo, SearchOwnerInfoComponent],
            [PlamsSearchOptions.TransferAttorneyInfo, SearchGroupInfoPlamsComponent],
            [PlamsSearchOptions.SellerInfo, SearchGroupInfoPlamsComponent],
            [PlamsSearchOptions.BuyerInfo, SearchGroupInfoPlamsComponent],
            [PlamsSearchOptions.LesseeInfo, SearchGroupInfoPlamsComponent],
            [PlamsSearchOptions.AlienationInfo, SearchDeedTransferDateComponent],
            [PlamsSearchOptions.LeaseContractInfo, SearchLeaseContractDateComponent]
        ]);
    }
    getSearchOptionLookup(selectedSearchOption) {
        const keys = [...this.searchOptionsMap.entries()]
            .filter(({ 1: v }) => v === selectedSearchOption)
            .map(([k]) => k);
        return keys.length > 0 ? keys[0].toString() : selectedSearchOption;
    }
    initializeApplicationTableColumnMap() {
        this.applicationTableColumnMapObservable = this.applicationTableColumnMap.asObservable();
        this.changeAppTableColumnMap(this.customApplicationTableColumnMap
            ? this.customApplicationTableColumnMap : applicationHeadingLookup);
    }
    changeAppTableColumnMap(tableColumnMap) {
        this.applicationTableColumnMap.next(tableColumnMap);
    }
    doSearchApplicationsByUser(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchApplicationsByResponsiblePerson(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchUnassignedApplications(moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUnassignedApplication(moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchApplicationsWithoutStartDate(moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsWithoutStartDate(moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "appId", true, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doApplicationSearch(search, moduleID, pageHeading, withDefaultColumns) {
        const column = this.getEntityColumn(search.column);
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsUsingSimpleSearch(search.text, column, this, moduleID, withDefaultColumns)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    // PropertyAndLease searches need the ModuleId as a separate parameter when "Groups" is included in the expand list
    getApplicationsQuery(params, useFullTableList) {
        const groupList = [ApplicationSearchConstants.SELLERS, ApplicationSearchConstants.BUYERS, ApplicationSearchConstants.TRANSFER_ATTORNEY, ApplicationSearchConstants.LESSEES];
        let mustExpand = false;
        groupList.forEach((group) => {
            // @ts-ignore
            if (params.updates !== undefined && params.updates && params.get("$expand").indexOf(group) > -1)
                mustExpand = true;
        });
        if (mustExpand)
            return this.getApplicationsQueryExtended(params, this.buildPLExtendedEndpoint(groupList));
        else
            return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint), { params });
    }
    getApplicationsQueryExtended(params, extendedEndPoint) {
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint, extendedEndPoint), { params });
    }
    getApplicationsSearchRequestWithAdditionalFilters(text, filter, moduleID) {
        let params = PlamsStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.oDataQueryService.filter(params, AflaModuleStrategyService.buildModuleIDFilter(moduleID), PlamsStrategyService_1.buildColumnFilter(text, filter));
        return this.getApplicationsQuery(params);
    }
    buildApplicationSearchBaseRequest(moduleID) {
        let params = PlamsStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.oDataQueryService.filter(params, PlamsStrategyService_1.buildModuleIDFilter(moduleID), PlamsStrategyService_1.showCompleteApplications());
        return this.getApplicationsQuery(params);
    }
    buildDashboardApplicationsSearch(moduleID, dashboardFilter) {
        let params = PlamsStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.applicationSearchService.dashboardSearch(params, dashboardFilter, moduleID);
        return this.getApplicationsQuery(params);
    }
    createApplication() {
        this.requestStatusService.showBusySpinner("CreatePLAMSApplication");
        const application = this.buildApplication();
        if (application === null) {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
            this.requestStatusService.removeBusySpinner("CreatePLAMSApplication");
            return;
        }
        this.createApplicationPlamsSubscription =
            this.postApplicationService(application)
                .subscribe({
                next: (savedApplication) => {
                    this.appController.showMessage(PlamsStrategyService_1.successMessage(savedApplication.jobId), AlertType.Success);
                    this.resetForm();
                    this.requestStatusService.removeBusySpinner("CreatePLAMSApplication");
                    this.router.navigate([
                        AppRoutingConstants.ROUTE_SEPERATOR + ApplicationsRoutingConstants.REFRESH_ROUTE,
                        {
                            jobId: savedApplication.jobId,
                            moduleId: this.appController.selectedModuleID,
                            type: ApplicationsRoutingConstants.REFRESH_VIEW_APPLICATION_ROUTE
                        }
                    ]);
                },
                error: (error) => {
                    this.requestStatusService.removeBusySpinner("CreatePLAMSApplication");
                    this.appController.handleServerErrorMessage("application", error, CRUDOperation.Add);
                }
            });
    }
    getApplicationGeometries(jobID, moduleID) {
        const params = {
            $select: "shape, leaseAreas, properties",
            $expand: "leaseAreas, properties",
            $filter: `jobId eq ${+jobID} and moduleId eq ${+moduleID}`
        };
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint), { params });
    }
    resetForm() {
        this.form.reset();
        this.form
            .get("propertiesForm")
            .get("properties").clear();
        this.form.get("noteForm").get("notes").clear();
    }
    postApplicationService(params) {
        return this.http.post(ApiPropertyAndLeaseConstants.URL, params);
    }
    getSelectedApplicationSummaryExpand() {
        return "status, applicant, applicant($expand=groups), applicantAgent, lastEditedUser";
    }
    getSearchUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_PL_APPLICATIONS_BY_USER;
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_CREATED_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_PL_APPLICATIONS_CREATED_BY_USER;
        }
    }
    getSearchResponsiblePersonUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_RESPONSIBLEPERSON:
                return ApiApplicationSearchConstants.FUNCTION_GET_PL_APPLICATIONS_BY_RESPONSIBLEPERSON;
        }
    }
    generateInvoiceReportService(applicationId, invoiceID, canDownloadInPortal = false) {
        const params = {
            invoiceId: invoiceID,
            canDownloadInPortal
        };
        return this.http.get(`${ApiPropertyAndLeaseConstants.URL}/${applicationId}/${ApiPropertyAndLeaseConstants.FUNCTION_GET_GENERATE_INVOICE}`, { responseType: "blob", params });
    }
    getRequiredDocumentsChecklist(applicationId, jobId) {
        const params = {
            $filter: jobId
        };
        return this.http.get(`${ApiPropertyAndLeaseConstants.URL}/${applicationId}/${ApiPropertyAndLeaseConstants.FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    getExternalLinks(moduleId, jobId, category) {
        var params = {
            jobId: jobId,
            category: category
        };
        return this.http.get(`${ApiPropertyAndLeaseConstants.URL}/${moduleId}/${ApiPropertyAndLeaseConstants.FUNCTION_GET_EXTERNAL_LINKS}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    buildPLExtendedEndpoint(groupList) {
        let url = `${ApiApplicationSearchConstants.FUNCTION_GET_PL_APPLICATIONS_WITH_GROUPS}`
            + `${ApiProxyConstants.QUERY_PREFIX}`
            + `${ApplicationSearchConstants.MODULE_ID}=${this.appControllerService.selectedModuleID}`;
        groupList.forEach((groupName) => {
            url += `${ApiProxyConstants.PARAMETER_PREFIX}groupNames=${groupName}`;
        });
        return url;
    }
    initForm() {
        // this.tableHeadingsIsChangedObservable = this.tableHeadingsIsChanged.asObservable()
        this.form = new FormGroup({
            applicantForm: new FormGroup({
                applicantRecipient: new FormControl(null, [Validators.required]),
                applicantAgentRecipient: new FormControl(null, [Validators.required]),
                copyApplicantDetails: new FormControl(null),
                markApplicantAgentAsNotApplicable: new FormControl(null)
            }),
            noteForm: new FormGroup({
                newNote: new FormControl(null),
                notes: new FormArray([]),
            }),
            detailsForm: new FormGroup({
                referenceNumber: new FormControl(null),
                description: new FormControl(null, [Validators.required]),
                applicationType: new FormControl(null, [Validators.required]),
                leaseType: new FormControl(null, [Validators.required]),
                leaseReason: new FormControl(null, [Validators.required]),
                lesseeType: new FormControl(null, [Validators.required]),
                lesseeRecipient: new FormControl(null, [Validators.required]),
                leaseUse: new FormControl(null, [Validators.required]),
                leaseRentalAgreementAmount: new FormControl(null, [Validators.required]),
                leaseStartDate: new FormControl(null, [Validators.required]),
                leaseEndDate: new FormControl(null, [Validators.required]),
                leaseContractNumber: new FormControl(null),
                leaseAccountNumber: new FormControl(null),
                leaseComments: new FormControl(null),
                leaseContractEscalation: new FormControl(null),
                leasePeriod: new FormControl(null),
                leaseNoticePeriod: new FormControl(null),
                leaseStatusAccordingToCouncilResolution: new FormControl(null),
                saleAmount: new FormControl(null, [Validators.required]),
                dateOfDeedTransfer: new FormControl(null, [Validators.required]),
                evaluationAmount: new FormControl(null, [Validators.required]),
                buyerRecipient: new FormControl(null, [Validators.required]),
                sellerRecipient: new FormControl(null, [Validators.required]),
                saleAmountAlienation: new FormControl(null, [Validators.required]),
                dateOfDeedTransferAlienation: new FormControl(null, [Validators.required]),
                evaluationAmountAlienation: new FormControl(null, [Validators.required]),
                transferringAttorneyRecipient: new FormControl(null),
            }),
            propertiesForm: new FormGroup({
                properties: new FormArray([], [Validators.minLength(1), Validators.required]),
                leaseArea: new FormControl(null),
            }),
        });
    }
    getEntityColumn(searchColumn) {
        switch (searchColumn) {
            case SharedConstants.SEARCH_BY_DEFAULT:
                return SharedConstants.SEARCH_BY_DEFAULT;
            case SharedConstants.DASHBOARD_FILTERS.LatestApplications:
                return SharedConstants.DASHBOARD_FILTERS.LatestApplications;
            case SharedConstants.DASHBOARD_FILTERS.OverdueApplications:
                return SharedConstants.DASHBOARD_FILTERS.OverdueApplications;
            case SharedConstants.DASHBOARD_FILTERS.OpenApplications:
                return SharedConstants.DASHBOARD_FILTERS.OpenApplications;
            case SharedConstants.DASHBOARD_FILTERS.ClosedApplications:
                return SharedConstants.DASHBOARD_FILTERS.ClosedApplications;
            case SharedConstants.DASHBOARD_FILTERS.TotalApplications:
                return SharedConstants.DASHBOARD_FILTERS.TotalApplications;
            case SharedConstants.DASHBOARD_FILTERS.ApplicationStatus:
                return this.statusColumn;
            default:
                return this.searchQueryLookup.get(searchColumn);
        }
    }
    buildApplication() {
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeRecipientProperties(applicantFormValue);
        const copyApplicantDetails = this.form.get("applicantForm").get("copyApplicantDetails").value;
        const markApplicantAgentAsNotApplicable = this.form.get("applicantForm").get("markApplicantAgentAsNotApplicable").value;
        let applicantAgent = null;
        const applicantAgentRecipientFormControl = this.form.get("applicantForm").get("applicantAgentRecipient");
        if (copyApplicantDetails) {
            this.recipientSelectService.setRecipient(applicantFormValue, true, applicantAgentRecipientFormControl, true);
        }
        if (copyApplicantDetails === true || markApplicantAgentAsNotApplicable === true) {
            const applicantAgentFormValue = this.form
                .get("applicantForm")
                .get("applicantAgentRecipient").value;
            applicantAgent = RecipientUtils.removeRecipientProperties(applicantAgentFormValue);
        }
        const application = {
            referenceNumber: "",
            deleted: false,
            moduleId: Number(this.appController.selectedModuleID),
            description: this.form.get("detailsForm").get("description").value,
            applicationType: this.form.get("detailsForm").get("applicationType").value.value,
            shape: "",
            wkid: 102100,
            applicant: [applicant],
            applicantAgent: [],
            notes: [],
            leaseAreas: [],
            properties: [],
            applicantAgentNa: !markApplicantAgentAsNotApplicable
        };
        if (copyApplicantDetails === true || markApplicantAgentAsNotApplicable === true) {
            application.applicantAgent.push(applicantAgent);
        }
        if (application.applicationType === "Lease") {
            const lessees = this.form.get("detailsForm").get("lesseeRecipient").value.recipients;
            if (lessees.length === 0) {
                return null;
            }
            lessees.forEach((lessee) => {
                lessee = RecipientUtils.removeRecipientProperties(lessee);
            });
            application.leaseType = this.form.get("detailsForm").get("leaseType").value.value;
            application.leaseReason = this.form.get("detailsForm").get("leaseReason").value;
            application.leaseUse = this.form.get("detailsForm").get("leaseUse").value;
            application.leaseRentalAgreementAmount = this.form.get("detailsForm").get("leaseRentalAgreementAmount").value;
            application.leaseStartDate = this.form.get("detailsForm").get("leaseStartDate").value;
            application.leaseEndDate = this.form.get("detailsForm").get("leaseEndDate").value;
            application.leaseLesseeType = this.form.get("detailsForm").get("lesseeType").value.value;
            application.lessees = lessees;
            const geometry = this.form.get("propertiesForm").get("leaseArea").value;
            if (geometry === null) {
                return null;
            }
            const leaseAreaGeometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
            const leaseArea = {
                wkid: 102100,
                shape: leaseAreaGeometryJSON,
            };
            application.leaseAreas.push(leaseArea);
        }
        else if (application.applicationType === "Alienation") {
            const buyers = this.form.get("detailsForm").get("buyerRecipient").value.recipients;
            if (buyers.length === 0) {
                return null;
            }
            buyers.forEach((buyer) => {
                buyer = RecipientUtils.removeRecipientProperties(buyer);
            });
            application.saleAmount = this.form.get("detailsForm").get("saleAmountAlienation").value;
            application.dateOfDeedTransfer = this.form.get("detailsForm").get("dateOfDeedTransferAlienation").value;
            application.evaluationAmount = this.form.get("detailsForm").get("evaluationAmountAlienation").value;
            application.buyers = buyers;
        }
        else if (application.applicationType === "Acquisition") {
            const sellers = this.form.get("detailsForm").get("sellerRecipient").value.recipients;
            if (sellers.length === 0) {
                return null;
            }
            sellers.forEach((seller) => {
                seller = RecipientUtils.removeRecipientProperties(seller);
            });
            application.saleAmount = this.form.get("detailsForm").get("saleAmount").value;
            application.dateOfDeedTransfer = this.form.get("detailsForm").get("dateOfDeedTransfer").value;
            application.evaluationAmount = this.form.get("detailsForm").get("evaluationAmount").value;
            application.sellers = sellers;
        }
        const notesArray = this.form.get("noteForm").get("notes");
        notesArray.controls.forEach((item) => {
            const note = {
                note: item.get("note").value,
            };
            application.notes.push(note);
        });
        const points = [];
        const propertiesArray = this.form
            .get("propertiesForm")
            .get("properties");
        propertiesArray.controls.forEach((item) => {
            const centroid = item.get("centroid").value;
            points.push(`(${centroid.x} ${centroid.y})`);
            const geometry = item.get("geometry").value;
            const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
            let owners = [];
            if (item.get("owners").value != null) {
                owners = item.get("owners").value.recipients;
                owners.forEach((owner) => {
                    owner = RecipientUtils.removeRecipientProperties(owner);
                });
            }
            const property = {
                address: item.get("address").value,
                allotment: item.get("allotment").value,
                erfNumber: item.get("erfNo").value,
                farmNumber: item.get("farmNo").value,
                zoning: item.get("zoning").value,
                streetNumber: item.get("streetNumber").value,
                streetName: item.get("streetName").value,
                town: item.get("town").value,
                isDummy: false,
                sgCode: item.get("sgCode").value,
                shape: geometryJSON,
                subdivision: item.get("subdivision").value,
                updateGeometry: false,
                wkid: 102100,
                owners,
            };
            application.properties.push(property);
        });
        const shape = `MULTIPOINT (${points.join(", ")})`;
        application.shape = shape;
        return application;
    }
    initializeBuildingUseSearchOptions() {
    }
    doSearchApplicationsByCreatedByUser(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsCreatedByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    getApplicationTypes(jobId, moduleId) {
        const params = {
            moduleId
        };
        const url = `${ApiPropertyAndLeaseConstants.URL}/${jobId}/${ApiPropertyAndLeaseConstants.FUNCTION_APPLICATION_TYPES}`;
        return this.http.get(url, { params });
    }
    saveDraftApplication() {
    }
    getDraftApplication() {
        return null;
    }
    static ctorParameters = () => [
        { type: SaShortDatePipe },
        { type: ApplicationSearchService },
        { type: AppControllerService },
        { type: OdataQueryService },
        { type: RequestStatusService },
        { type: HttpClient },
        { type: AppControllerService },
        { type: Router },
        { type: RecipientSelectService }
    ];
};
PlamsStrategyService = PlamsStrategyService_1 = __decorate([
    Injectable({
        providedIn: "root",
    }),
    AutoUnsub()
], PlamsStrategyService);
export { PlamsStrategyService };
